import * as React from 'react'
import * as PropTypes from 'prop-types'

import DialogModal from '../../ui/DialogModal/DialogModal'

class IdleTimeout extends React.Component {
  constructor(props) {
    super(props)

    const { lastAccessed } = this.props

    this.state = {
      refTime: lastAccessed,
      lastUpdate: null,
      timeoutTime: null,
      lastPaused: null,
    }

    this.timer = null
  }

  componentDidMount() {
    const {
      timeout,
      timeoutNotice,
      refreshEvents,
      startOnMount,
      accessToken,
      onTimeout,
    } = this.props

    const { refTime, lastUpdate } = this.state

    refreshEvents.forEach(e => {
      window.addEventListener(e, this.refresh, false)
    })

    const timeoutTime = timeout * 1000
    const timeoutTimeNotice = timeoutNotice * 1000

    this.setState(
      {
        timeoutTime,
        timeoutTimeNotice,
      },
      () => {
        const hasTimedOut =
          lastUpdate - refTime > timeoutTime + timeoutTimeNotice
        if (hasTimedOut) {
          this.pause(onTimeout)
        } else if (startOnMount && accessToken) {
          this.doStart()
        }
      },
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      refTime,
      lastUpdate,
      timeoutTime,
      timeoutTimeNotice,
      lastPaused,
    } = this.state

    const {
      onTimeout,
      refTime: refTimeProps,
      accessToken,
      setTimeOutNotice,
      showTimeOutNotice,
    } = this.props

    if (prevProps.accessToken !== accessToken) {
      if (accessToken) {
        this.restart()
      } else {
        this.pause(onTimeout)
      }
    }

    if (lastPaused !== null) {
      if (prevProps.refTime !== refTimeProps) {
        this.restart()
      }
    } else if (
      lastUpdate !== prevState.lastUpdate ||
      refTime !== prevState.refTime ||
      timeoutTime !== prevState.timeoutTime ||
      timeoutTimeNotice !== prevState.timeoutTimeNotice ||
      showTimeOutNotice !== prevProps.showTimeOutNotice
    ) {
      const hasTimedOut = lastUpdate - refTime > timeoutTime + timeoutTimeNotice
      const timeOutNotice = lastUpdate - refTime
      if (
        timeOutNotice > timeoutTimeNotice &&
        !showTimeOutNotice &&
        !prevProps.showTimeOutNotice
      ) {
        setTimeOutNotice(true)
        this.countDownStart(
          Math.floor(
            (refTime - lastUpdate + timeoutTimeNotice + timeoutTime) / 1000,
          ),
        )
      }
      if (hasTimedOut) {
        this.pause(onTimeout)
      }
    }
  }

  componentWillUnmount() {
    const { refreshEvents } = this.props
    refreshEvents.forEach(e => {
      window.removeEventListener(e, this.refresh)
    })
  }

  doStart = () => {
    clearInterval(this.timer)
    this.refresh()
    this.update()
    this.timer = setInterval(this.update, 250)
  }

  refresh = () => {
    const { setLastAccessed } = this.props
    const { refTime } = this.state
    const now = Date.now()

    if ((now / 1000).toFixed(0) !== (refTime / 1000).toFixed(0)) {
      setLastAccessed(now)

      setTimeout(() => {
        this.setState({
          refTime: now,
        })
      })
    }
  }

  update = () => {
    this.setState({
      lastUpdate: Date.now(),
    })
  }

  restart = () => {
    const { setLastAccessed } = this.props
    this.setState(
      () => {
        const now = Date.now()
        setLastAccessed(now)

        return {
          lastPaused: null,
          lastUpdate: now,
          refTime: now,
        }
      },
      () => {
        this.doStart()
      },
    )
  }

  pause = cb => {
    const { setTimeOutNotice } = this.props

    this.setState(
      {
        lastPaused: Date.now(),
      },
      () => {
        setTimeOutNotice(false)
        clearInterval(this.timer)
        cb()
      },
    )
  }

  countDownStart = countdown => {
    this.setState({
      countdown,
    })
    clearInterval(this.countdown)
    this.countdown = setInterval(() => this.countDownTick(), 1000)
  }

  countDownTick = () => {
    const { showTimeOutNotice, onTimeout } = this.props
    const { countdown } = this.state

    if (!showTimeOutNotice) {
      clearInterval(this.countdown)
    }

    if (countdown === 0) {
      clearInterval(this.countdown)
      this.pause(onTimeout)
      return
    }

    this.setState({
      countdown: countdown - 1,
    })
  }

  leadingZero = (val, length = 2) => {
    const value = val.toString()
    let newValue = ''

    for (let i = value.length; i < length; i++) {
      newValue += '0'
    }

    newValue += value

    return newValue
  }

  timeFormat = value => {
    const minutes = Math.floor(value / 60)
    const seconds = value % 60

    return `${this.leadingZero(minutes)}:${this.leadingZero(seconds)}`
  }

  render() {
    const { setTimeOutNotice, showTimeOutNotice, onTimeout } = this.props
    const { countdown } = this.state

    return (
      <DialogModal
        modalState={showTimeOutNotice}
        title="Inactive"
        description={
          <>
            <div>
              Still there? You will be logged out after 5 minutes of inactivity
            </div>
            <p>{this.timeFormat(countdown)}</p>
          </>
        }
        customOverlay={{
          zIndex: 99999,
        }}
        okText="Keep me logged-in"
        cancelText="Log out"
        onOk={() => setTimeOutNotice(false)}
        onCancel={() => this.pause(onTimeout)}
        align="center"
      />
    )
  }
}

IdleTimeout.defaultProps = {
  refreshEvents: 'click keydown scroll mousemove'.split(' '),
  onTimeout: null,
  timeout: 300,
  timeoutNotice: 150,
}

IdleTimeout.propTypes = {
  refreshEvents: PropTypes.arrayOf(PropTypes.string),
  onTimeout: PropTypes.func,
  timeout: PropTypes.number,
  timeoutNotice: PropTypes.number,
}

export default IdleTimeout
